import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { UnidadeService } from '../services/unidade.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-unidades',
	templateUrl: './unidades.component.html',
	styleUrls: ['./unidades.component.css'],
	animations: [loadingFade, modal, alert]
})
export class UnidadesComponent implements OnInit {
	public loading = false;
	public unidades = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	constructor(private fb: FormBuilder,
		private unidadeSvc: UnidadeService,
		private authSvc: AuthService) { }

	ngOnInit() {
		this.loading = true;
		this.pegaUnidades();
	}

	pegaUnidades() {
		this.unidadeSvc.getUnidades().then((data: any) => {
			this.unidades = data;
			this.count = this.unidades.length;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaUnidade(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.unidadeSvc.apagaUnidade(id).then((data) => {
					this.pegaUnidades();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	onChangeStatus(unidade_id, event){
		this.loading = true;
		let status = event.srcElement.checked == true ? 'A' : 'I';
		let toSend = ({
		  'unidade_id': unidade_id,
		  'unidade_status': status,
		});
		
		this.unidadeSvc.atualizaStatus(toSend).then((data) => {
		  this.loading = false;
		  Swal.fire({
			type: 'success',
			title: 'Status alterado com sucesso!'
		  });
		}).catch(err => {
		  console.log(err);
		  this.loading = false;
		  Swal.fire({
			type: 'error',
			title: 'Ops! Algo de errado aconteceu!',
			text: 'Tente novamente mais tarde.'
		  });
		});
	}

	exportarExcel(){
		// let data = [];
		// if(this.dadosFiltrados.length == 0){
		// 	this.dadosFiltrados = this.profissionais;
		// }
		// for(let index in this.dadosFiltrados){
		// 	data[index] = {
		// 		'Veículo': this.profissionais[index].veiculo.veiculo_placa,
		// 		'Profissional': this.profissionais[index].profissional == null ? '' : this.profissionais[index].profissional.profissional_nome,
		// 		'Tipo de Produto': this.profissionais[index].tipo_profissionai.tipo_profissionai_nome,
		// 		'Natureza': this.profissionais[index].tipo_profissionai.tipo_profissionai_natureza,
		// 		'Pontuação': this.profissionais[index].tipo_profissionai.tipo_profissionai_pontuacao,
		// 	};
		// }
		// this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Produtos');
	}

}
